import { render } from "./CustomSelect.vue?vue&type=template&id=61147135&ts=true"
import script from "./CustomSelect.vue?vue&type=script&lang=ts"
export * from "./CustomSelect.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__